import { JwtDecodedUser } from '../../models/UserModels';
import { getMyPMISiteUrl } from '../../env-vars';
import styles from './profileName.module.scss';

export function ProfileName({
  user,
  navigateToMyPmi = false,
}: {
  user: JwtDecodedUser;
  navigateToMyPmi?: boolean;
}) {
  const content = (
    <span className={`m-0 p-0 ${styles.profileMenuItemText}`} data-exclude-lg>
      <span className="me-1">{user?.given_name ?? ''}</span>
      <span>{user?.family_name ?? ''}</span>
    </span>
  );

  // Only render an interactive button when this navigates; otherwise it may sit inside another trigger button (e.g. Popover), and nesting buttons is invalid HTML.
  if (!navigateToMyPmi) {
    return <div>{content}</div>;
  }

  return (
    <button
      type="button"
      onClick={() => {
        window.location.href = getMyPMISiteUrl();
      }}
    >
      {content}
    </button>
  );
}

export function ProfileImage({ url }: { url: string }) {
  return (
    <span className={`${styles.profileImageContainer} me-2`} data-exclude-lg>
      {url && <img src={url} alt="profile" />}
    </span>
  );
}
